import { Svg, Path } from '@react-pdf/renderer'

export default function TopMark() {
    return (
        <Svg fixed={true} style={{ position: 'absolute', top: '0', left: '58px' }} width="24" height="21" viewBox="0 0 18 16" fill="none">
            <Path d="M17.1845 0L8.59893 15.6506L0 0H17.1845Z" fill="#EF7D00" />
        </Svg>
    )
}
